import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { BlogCard } from "@/components/BlogPreview";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";
import { BLOG_CATEGORIES } from "@/data/site";

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const q = cat === "All" ? "" : `?category=${encodeURIComponent(cat)}`;
    api.get(`/blog${q}`).then(({ data }) => setPosts(data)).finally(() => setLoading(false));
  }, [cat]);

  return (
    <div className="App bg-ink">
      <Header />
      <main className="mx-auto max-w-7xl px-5 pb-24 pt-36 lg:px-8 lg:pt-44" data-testid="blog-page">
        <Reveal>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-orange">The Blog</p>
          <h1 className="font-display text-5xl font-black tracking-tighter sm:text-6xl lg:text-7xl">
            Amazon growth, <span className="text-gradient">decoded.</span>
          </h1>
          <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-muted">
            Strategy, A+ content craft and PPC updates from the DNA eCommerce Ads team.
          </p>
        </Reveal>

        <div className="mt-10 flex flex-wrap gap-3" data-testid="blog-filters">
          {BLOG_CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`filter-${c.replace(/\s+/g, "-").toLowerCase()}`}
              className={`rounded-full border px-4 py-2 text-sm transition-colors ${
                cat === c ? "border-orange bg-orange text-white" : "border-white/15 text-muted hover:text-white"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {loading ? (
          <p className="mt-16 text-muted">Loading…</p>
        ) : posts.length === 0 ? (
          <p className="mt-16 text-muted" data-testid="blog-empty">No articles in this category yet.</p>
        ) : (
          <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.06}>
                <BlogCard post={p} />
              </Reveal>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
